import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RouterShape from './utils/router-shape';

function getMuster(props) {
  const muster = props.muster || props.routes;

  if (!muster) {
    throw new Error(
      'Could not find `muster` instance in props of `Provider`. ' +
      'Expected to find it in either the `muster` or `routes` prop.'
    );
  }

  return muster;
}

/**
 * Provider
 *
 * @example
 * <Provider muster={routes}>
 *   <App />
 * </Provider>
 */
class Provider extends PureComponent {
  constructor(props) {
    super(props);

    // call get to check that muster is provided on element creation
    getMuster(props);
  }

  getChildContext() {
    return {
      subscribe: this.subscribe.bind(this),
      set: this.set.bind(this),
      call: this.call.bind(this),
      muster: getMuster(this.props),
    };
  }

  subscribe(paths, handler) {
    // TODO: error handling, complete handling
    const subscription = getMuster(this.props).get(paths).subscribe(handler);

    return subscription;
  }

  set(path, value) {
    return getMuster(this.props).set(path, value);
  }

  call(path, ...args) {
    return getMuster(this.props).call(path, ...args);
  }

  render() {
    return this.props.children;
  }
}

Provider.propTypes = {
  routes: RouterShape, // deprecated
  muster: RouterShape,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Provider.childContextTypes = {
  subscribe: PropTypes.func,
  unsubscribe: PropTypes.func,
  set: PropTypes.func,
  call: PropTypes.func,
  muster: RouterShape,
};

export default Provider;
